<template>
  <AtomLoadingPrimary/>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionLoading'
}
</script>
